import { useIntl } from 'react-intl';

import { Layout } from '~/eds/src/components/Layout/Layout';
import { PageLayout } from '~/eds/src/modules/PageLayout/PageLayout';
import { LocaleSelect } from '~/features/locale-select/LocaleSelect';
import { AccountInformation } from '~/features/settings/AccountInformation';
import { ChangePassword } from '~/features/settings/ChangePassword';
import { FlagType } from '~/flags/flags';
import { useFlag } from '~/flags/useFlag';
import { useCurrentUser } from '~/hooks/useCurrentUser';
import { api } from '~/redux/api/createApi';

const Page = () => {
  const intl = useIntl();
  const currentUser = useCurrentUser();
  const { data: isWorkdayUser = false, isLoading: isLoadingExternalUser } =
    api.endpoints.getIsWorkdayUser.useQuery({});

  const hasLocalization = useFlag(FlagType.LanguageSelect);

  return (
    <PageLayout
      title={intl.formatMessage({
        id: 'Settings.pageTitle',
        defaultMessage: 'Settings',
        description: 'Page title for settings page',
      })}
      loadingContent={{
        isLoading: !Object.keys(currentUser).length || isLoadingExternalUser,
      }}
      children={
        <Layout preset="sections">
          <AccountInformation isWorkdayUser={isWorkdayUser} />
          <ChangePassword isWorkdayUser={isWorkdayUser} />
          {!isWorkdayUser && hasLocalization && <LocaleSelect />}
        </Layout>
      }
    />
  );
};

export default Page;
